(() => {
  const roots = document.querySelectorAll('[data-pfg-page]');

  const emit = (name, detail = {}) => {
    const payload = Object.assign({ event: `pupadour_${name}`, page_type: 'for_groomers' }, detail);

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    document.dispatchEvent(new CustomEvent('pupadour:for-groomers', { detail: payload }));
  };

  roots.forEach((root) => {
    const reveals = root.querySelectorAll('[data-pfg-reveal]');

    if (reveals.length) {
      root.classList.add('pfg-motion-ready');

      if ('IntersectionObserver' in window) {
        const revealObserver = new IntersectionObserver((entries, observer) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        }, { threshold: 0.18 });

        reveals.forEach((element) => revealObserver.observe(element));
      } else {
        reveals.forEach((element) => element.classList.add('is-visible'));
      }
    }

    root.querySelectorAll('[data-pfg-event]').forEach((element) => {
      element.addEventListener('click', () => {
        emit(element.dataset.pfgEvent, element.dataset.pfgScent ? { scent: element.dataset.pfgScent } : {});
      });
    });

    const form = root.querySelector('.pfg-form');
    if (!form) return;

    let started = false;
    let submitted = false;

    form.addEventListener('input', () => {
      if (started) return;
      started = true;
      emit('inquiry_form_start');
    }, { once: true });

    form.addEventListener('submit', () => {
      submitted = true;
      emit('inquiry_form_submit');
    });

    window.addEventListener('pagehide', () => {
      if (started && !submitted) emit('inquiry_form_abandon');
    }, { once: true });
  });
})();
